import React from 'react';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

// Reusable date range filter component
export const DateRangeFilter = ({ selectedKeys, setSelectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
        <RangePicker
            style={{ width: 250 }}
            // Ensure selectedKeys and selectedKeys[0] exist before trying to split/parse
            value={selectedKeys && selectedKeys[0] ? [dayjs(selectedKeys[0].split('|')[0]), dayjs(selectedKeys[0].split('|')[1])] : null}
            onChange={(dates) => {
                // Ensure dates exist and have two elements before creating the string
                if (dates && dates[0] && dates[1]) {
                    setSelectedKeys([`${dates[0].toISOString()}|${dates[1].toISOString()}`]);
                } else {
                    setSelectedKeys([]); // Clear selection
                }
            }}
        />
        <div style={{ marginTop: 8 }}>
            <Button type="primary" onClick={() => confirm()} size="small">
                Filter
            </Button>
            <Button 
                onClick={() => {
                    setSelectedKeys([]); // Explicitly clear our state representation
                    if (clearFilters) clearFilters(); // Call AntD's clear function
                    confirm(); // Confirm to apply the cleared filter
                }} 
                size="small" 
                style={{ marginLeft: 8 }}
            >
                Reset
            </Button>
        </div>
    </div>
);

// Helper to check if record is in date range
export const isInDateRange = (value, dateField) => {
    // Add some robustness
    if (!value || typeof value !== 'string') return false;
    const parts = value.split('|');
    if (parts.length !== 2) return false;

    const [startStr, endStr] = parts;
    const recordDate = dayjs(dateField);
    const startDate = dayjs(startStr);
    const endDate = dayjs(endStr);

    // Ensure all dates are valid before comparison
    if (!recordDate.isValid() || !startDate.isValid() || !endDate.isValid()) {
        return false;
    }

    return recordDate.isBetween(startDate, endDate.endOf('day'), null, '[]'); // '[]' includes start and end dates
};